import { Link } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";

const NotFound = () => (
  <Layout>
    <section className="container-page py-32 text-center max-w-xl">
      <p className="eyebrow justify-center mb-4 text-accentInk">404</p>
      <h1 className="font-display text-5xl font-bold mb-4">Page not found</h1>
      <p className="text-muted-foreground text-lg mb-8">The page you're looking for doesn't exist or has been moved.</p>
      <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 font-semibold">
        <Link to="/">Back to Home</Link>
      </Button>
    </section>
  </Layout>
);
export default NotFound;
